import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_drop_zone = _resolveComponent("drop-zone")!

  return (_openBlock(), _createBlock(_component_drop_zone, {
    "allowed-extensions": _ctx.allowedExtensions,
    onDrop: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selected', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item, { clickable: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { avatar: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "fa fa-upload" })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.placeholder), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["allowed-extensions"]))
}